import axiosClient from "axiosClient";
import { axiosHyperwolfClient } from "axiosClient";
import { getQueryString } from "utilities/common";

export async function getSubTraitsListingAPI(filters) {
    return await axiosClient.get(`/api/v1/product/traits/sub/listing?${getQueryString(filters)}`);
}

export async function createSubTraitAPI(data){
    return await axiosClient.post('/api/v1/product/traits/sub/create', data);
}

export async function deleteSubTraitAPI(slug,platform){
    return await axiosHyperwolfClient.delete(`/api/v1/product/sub/delete/${slug}?platformType=${platform}`)
}

export async function getSubTraitByIdAPI(slug, data){
    return await axiosClient.get(`/api/v1/product/traits/sub/${slug}?${getQueryString(data)}`)
}

export async function updateSubTraitAPI(data, slug, platform){
    return await axiosHyperwolfClient.put(`/api/v1/product/trait/sub/update/${slug}`, data)
    // return await axiosClient.put(`/api/v1/product/traits/sub/update/${slug}`, data)

}

export async function getSubTraitCarouselListingApi(filters) {
    return await axiosClient.get(`/api/v1/product/traits/subtraits/carousel/listing?${getQueryString(filters)}`);
}

